<template>
  <div
    v-if="issues.length > 0"
    class="payment-issues"
  >
    <div
      v-for="(issue, index) in issues"
      :key="index"
      class="payment-issues__issue"
    >
      {{ issue }}
    </div>
  </div>
</template>

<script lang="ts">
/**
 * Used to render payment/subscription issues for a customer in a self-contained
 * way.
 *
 * Currently only render a message if the customer subscription status is one of
 * the problematic statuses, but it implemented in such a way that it could
 * potentially be expanded with more messages.
 */
export default { name: 'CBBPaymentIssues' }
</script>

<script setup lang="ts">
import { computed } from 'vue'

import { StripeSubscriptionStatus } from '@/modules/Billing/types'
import { useBillingStore } from '@/modules/Billing/useBillingStore'

const billingStore = useBillingStore()

// the goal of returning an array here is to be able to
// support and display multiple payment issues in the future
const issues = computed<string[]>(() => {
  if (!billingStore.billingInfo) {
    return []
  }

  const status = billingStore.billingInfo.customer.stripe_subscription_status

  const badStatuses: StripeSubscriptionStatus[] = [
    StripeSubscriptionStatus.Unpaid,
    StripeSubscriptionStatus.IncompleteExpired,
    StripeSubscriptionStatus.PastDue,
  ]

  if (!!status && badStatuses.includes(status)) {
    return ['Billing Status: Payment failed - Update payment details or contact your bank.']
  }

  return []
})
</script>

<!-- eslint-disable vue-scoped-css/enforce-style-type -->
<style lang="scss">
.payment-issues__issue {
  color: $colorPink;
}
</style>
